module.exports = "/_next/static/images/macbook-performance-2x-af06055502c17437285aa733f2d92519.png.webp";